var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCopy18 = function SvgLightIcnCopy18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 2.579H5.091c-.843 0-1.526.699-1.526 1.562v7.162c0 .862.683 1.561 1.526 1.561h5.327c.844 0 1.527-.699 1.527-1.562V4.142c0-.863-.683-1.562-1.527-1.562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.054 13.848c0 .868.69 1.562 1.527 1.562h5.315c.849 0 1.527-.706 1.527-1.562v-7.15c0-.868-.69-1.562-1.527-1.562"
  })));
};
export default SvgLightIcnCopy18;